import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs/internal/Observable';
import { BaseDialogComponent } from 'src/app/core/components/base-dialog.component';
import { HelpTextService, HelpTextViewModel } from 'src/app/core/services/api-services';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
  selector: 'app-help-text-dialog',
  templateUrl: './help-text-dialog.component.html',
  styleUrls: ['./help-text-dialog.component.scss']
})
export class HelpTextDialogComponent extends BaseDialogComponent {
  helpTextView$: Observable<HelpTextViewModel | null>;

  constructor(
    private readonly helpTextService: HelpTextService,
    protected readonly messageService: MessageService,
    protected override readonly matDialogRef: MatDialogRef<HelpTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { key: string }) {
    super(matDialogRef);
    this.helpTextView$ = this.helpTextService.getView(data.key);
  }
}
